import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useAddConsultationService = (consultationId) => {
  const queryClient = useQueryClient();

  const handleNetworkError = useHandleNetworkError("Error adding service");
  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (serviceId) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/consultationservice`,
        {
          consultationId: Number(consultationId),
          serviceId: Number(serviceId),
        }
      );
      return response.data;
    },
    onSuccess: () => {
      toast.success("Service added successfully");
      queryClient.invalidateQueries({ queryKey: ["consultationServices"] });
      queryClient.invalidateQueries({ queryKey: [consultationId] });
      queryClient.invalidateQueries({ queryKey: ["consultationPaymentsDue"] });
      queryClient.invalidateQueries({ queryKey: ["consultation"] });
      queryClient.invalidateQueries({ queryKey: ["activeConsultation"] });
    },
    onError: handleNetworkError,
  });
};
